module.exports = __webpack_public_path__ + "img/br6.575ca3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br6.jpg
// module id = rlbV
// module chunks = 0